module.exports = __webpack_public_path__ + "media/images/emblems/Cuarnens-coat_of_arms-ac4580f8fbce04e837618008d874ee06.svg";